import { createSlice } from "@reduxjs/toolkit";

const typeCard = createSlice({
  name: "type",
  initialState: {
    type: "",
  },
  reducers: {
    addTypeCard(state, { payload }) {
      state.type = payload;
    },
  },
});
export const { addTypeCard } = typeCard.actions;
export default typeCard.reducer;
